import React from "react";
import { companyInfo, leadership, promisePoints } from "../../data/siteData";

function About() {
  return (
    <div className="page">
      <section className="page-hero">
        <p className="section-eyebrow">About Touchmark</p>
        <h1>Long-term fabrication experience backed by design awareness and site discipline.</h1>
        <p>
          {companyInfo.name} is a limited liability company registered since{" "}
          {companyInfo.founded} under {companyInfo.rcNumber}. The company operates
          from Abuja with Lagos and Enugu reach, serving residential and commercial
          clients across Nigeria.
        </p>
      </section>

      <section className="section split-section">
        <div>
          <h2>Who the company is</h2>
          <p>
            Touchmark specializes in metal fabrication, modern wrought iron, laser-cut
            design work, stainless steel installations and decorative metal ornaments.
            The business also works alongside trusted partners for larger construction
            delivery, contemporary furniture and local OEM relationships in Abuja.
          </p>
          <p>
            The workshop team includes experienced supervision, skilled welders and
            finishing support, with state-of-the-art mobile bending tools that can be
            deployed to site when required.
          </p>
        </div>

        <div className="stacked-cards">
          <article className="info-card info-card--compact">
            <h3>Mission</h3>
            <p>
              Deliver timely, innovative and high-quality metal and wrought iron work
              at a cost clients can plan around.
            </p>
          </article>
          <article className="info-card info-card--compact">
            <h3>Vision</h3>
            <p>
              Help redefine how metal fabrication and wrought iron work are experienced
              in homes and the construction industry.
            </p>
          </article>
          <article className="info-card info-card--compact">
            <h3>Competitive edge</h3>
            <p>
              Workshop-backed production, mobile bending capability and leadership that
              understands both aesthetics and execution.
            </p>
          </article>
        </div>
      </section>

      <section className="section section--contrast">
        <div className="section-heading">
          <p className="section-eyebrow">Leadership</p>
          <h2>The business is guided by experience across operations, design and administration.</h2>
        </div>
        <div className="card-grid card-grid--leaders">
          {leadership.map((leader) => (
            <article key={leader.name} className="info-card">
              <p className="card-kicker">{leader.role}</p>
              <h3>{leader.name}</h3>
              <p>{leader.bio}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section split-section">
        <div>
          <p className="section-eyebrow">How Touchmark works</p>
          <h2>Practical delivery for projects that still need a refined finish.</h2>
        </div>
        <div className="stacked-cards">
          {promisePoints.map((point) => (
            <article key={point.title} className="info-card info-card--compact">
              <h3>{point.title}</h3>
              <p>{point.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="section-heading">
          <p className="section-eyebrow">Locations</p>
          <h2>Operating from Abuja with support for projects across multiple cities.</h2>
        </div>
        <div className="card-grid card-grid--locations">
          {companyInfo.officeAddresses.map((address) => (
            <article key={address} className="info-card info-card--compact">
              <p>{address}</p>
            </article>
          ))}
          <article className="info-card info-card--compact">
            <p>{companyInfo.serviceArea}</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default About;
